import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkStepper from "../../components/atoms/TkStepper";
import TkTable from "../../components/atoms/TkTable";
import TkButton from "../../components/atoms/TkButton";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import { httpAPI_STA003, httpAPI_STA008, httpAPI_BUS009 } from "./api/request";
import {
  funInfoBodyList,
  funWorkingDayNumInfoBodyList,
  judgeBusinessType,
  makeExclusionMonthObj,
} from "./hooks/useHooks";
import {
  fakeTableList,
  infoHeadTitleList,
  months,
  schema,
  stepperRetirement,
  stepperTransfer,
} from "./parts";
import "./_style.scss";
import { API_STA008_BuildReqParams } from "../../utils/buildRequestParams";
import "./_style.scss";
import _ from "lodash";
import { IJob_32Props } from "../../type/contextType/businessContext/IJob_32";
import { IAPI_STA003_Response } from "../../type/apiType";
import { getFiscalYear } from "../../utils/useTools";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import { headListWorkingDayNum } from "./parts";
dayjs.extend(isBetween);

/**
 * SCRC060122 退職情報　登録（従業状況の確認）
 * @return SCRC060122 退職情報　登録（従業状況の確認）
 */
const SCRC060122 = (): JSX.Element => {
  const navigate = useNavigate();

  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);

  const isKiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const context = businessState.job_32;
  const contractorNo = isKiko
    ? businessState.common?.contractorNo
    : state.authInfo?.contractorNo;
  const isJob33 = businessState.common?.businessType === "JOB-33";
  const [stateInfoList, setStateInfoList] = useState<any>([]);
  const ref = useRef<{
    getAllValue(): unknown;
    submit: (submitButtonGroup?: boolean) => void;
  } | null>(null);
  const isTempSave = useRef(false);
  const [childcareLeaveList, setChildcareLeaveList] = useState<any>([]);
  const [childcareLeaveWorkingDayNumList, setChildcareLeaveWorkingDayNumList] =
    useState<any>([]);
  // 退職の場合／継続異動の場合
  const [isRetirement, setIsRetirement] = useState(true);
  // 一時保存ダイヤログ
  const [openSuccess, setOpenSuccess] = useState(false);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const [dayNum, setDayNum] = useState(0);

  //初期表示
  const handleInit = async () => {
    try {
      // 退職者情報詳細参照API 呼び出し
      const res = await httpAPI_STA003({
        contractorNo: contractorNo,
        staffNo: context?.staffNo,
        applyId: context?.applyId,
      });

      if (res.resultCd === "I0000") {
        let resArr = stateFakeTableList.current;
        let exclusionMonth = resArr.find(
          (item) => item.keyword === "exclusionMonth"
        )!;

        // 契約者（法人）名
        let contractorName = resArr.find(
          (item) => item.keyword === "contractorName"
        )!;
        contractorName.showLine = isKiko;
        contractorName.contractorNumber =
          businessState.common?.contractorNo +
          ":" +
          businessState.common?.contractorName;

        let checkboxList = [];
        let newContext = { ...context };
        // 退職年度のならない月
        Object.values(months).forEach((i) => {
          let contextObj = context as IJob_32Props;
          let targetObj = exclusionMonth.checkBoxList?.find(
            (item) => item.key === i
          )!;

          if (targetObj) {
            let contextMonthData = contextObj?.[i as keyof IJob_32Props];
            let resMonthData = res[i as keyof IAPI_STA003_Response];
            let newTargetObj =
              (contextMonthData === "0" && resMonthData === "1") ||
              (contextMonthData === "1" && resMonthData === "0")
                ? contextMonthData
                : resMonthData;
            newContext[i as keyof IJob_32Props] = newTargetObj as any;

            switch (newTargetObj) {
              case "1":
                checkboxList.push(targetObj.label);
                break;

              case "2":
                targetObj.disabled = true;
                break;

              case "3":
                checkboxList.push(targetObj.label);
                targetObj.disabled = true;
                break;
            }
          }
        });

        let retireDate = new Date(context?.retireDate!);
        let retireMonth = retireDate.getMonth() + 1;
        let retireDay = retireDate.getDate();

        if (isJob33) {
          setIsRetirement(false);
          let workingDayNum = resArr.find(
            (item) => item.keyword === "workingDayNum"
          )!;
          workingDayNum.showLine = true;
          setDayNum(retireDay);
        }

        // 退職月の退職日が月初から10日以内の場合、チェックボックスを選択する
        let isChildcareLeave = false;
        res.childcareLeaveList?.forEach((item) => {
          const targetDate = dayjs(context?.retireDate, "YYYYMM");
          const startDate = dayjs(item.startDate, "YYYYMM");
          const endDate = dayjs(item.endDate, "YYYYMM");
          if (targetDate.isBetween(startDate, endDate, "month", "[]")) {
            isChildcareLeave = true;
          }
        });
        let retireMonthCheckbox = exclusionMonth.checkBoxList?.find(
          (item) => item.key === months[retireMonth]
        )!;
        if (retireDay <= 10) {
          if (!isChildcareLeave) {
            checkboxList.push(retireMonthCheckbox.label);
            retireMonthCheckbox.disabled = true;
          }
        }
        if (isJob33) {
          retireMonthCheckbox.disabled = true;
        }

        let currentMonth = retireMonth;
        let end = currentMonth > 3 ? 15 : 3;
        for (let i = ++currentMonth; i <= end; i++) {
          let month = i > 12 ? i - 12 : i;
          let targetObj = exclusionMonth.checkBoxList?.find(
            (item) => item.key === months[month]
          )!;
          checkboxList = checkboxList.filter(
            (item) => item !== targetObj.label
          );
          targetObj.disabled = true;
        }

        !checkboxList.length && checkboxList.push("無");
        exclusionMonth.setDefaultValue = checkboxList;

        // 職員番号
        let staffNo = resArr.find((item) => item.keyword === "staffNo")!;
        staffNo.text = context?.staffNo;

        // 退職者名
        let retireeName = resArr.find(
          (item) => item.keyword === "retireeName"
        )!;
        retireeName.text = context?.staffNameKanji;

        // 退職月の出勤日数
        let workingDayNum = resArr.find(
          (item) => item.keyword === "workingDayNum"
        )!;
        workingDayNum.setDefaultValue = context?.workingDayNum;
        workingDayNum.onGetInputValue = (e: any) => {
          handleChangeWorkingDayNum(
            retireMonth,
            retireDay,
            isChildcareLeave,
            e.target?.value
          );
        };

        setStateInfoList([...resArr]);

        setChildcareLeaveList(funInfoBodyList(res.childcareLeaveList));

        setChildcareLeaveWorkingDayNumList(
          funWorkingDayNumInfoBodyList(res.childcareLeaveWorkingDayNumList)
        );

        setState({
          ...state,
          errorMsgId: "",
        });

        // 申請前6か月本俸設定用リストを編集
        const sixMonthsSalaryBeforeApplySettingList =
          context?.sixMonthsSalaryBeforeApplySettingList?.map((item) => {
            const yearMonth = dayjs(`${item.yearMonth}`, "YYYYMM");
            const month = yearMonth.month() + 1;
            const isRetirementYear =
              getFiscalYear(yearMonth) === getFiscalYear(context?.retireDate);
            const resMonthData =
              res.sixMonthsSalaryBeforeApplySettingList?.find(
                (i) => item.yearMonth === i.yearMonth
              );

            return {
              ...item,
              unaccountedMonth: isRetirementYear
                ? (newContext[months[month] as keyof IJob_32Props] as string)
                : resMonthData?.unaccountedMonth,
            };
          });

        setBusinessState({
          ...businessState,
          job_32: {
            ...newContext,
            childcareLeaveRegistrationInfo: {
              childcareLeaveInfoList: res.childcareLeaveList,
              childcareActiveListList: res.childcareLeaveWorkingDayNumList,
            },
            sixMonthsSalaryBeforeApplySettingList,
          },
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeWorkingDayNum = (
    month: number,
    day: number,
    isChildcareLeave: boolean,
    dayNum: number
  ): void => {
    if (
      (!dayNum && dayNum !== 0) ||
      dayNum > day ||
      isChildcareLeave ||
      day <= 10
    )
      return;

    let resArr = stateFakeTableList.current;
    let exclusionMonth = resArr.find(
      (item) => item.keyword === "exclusionMonth"
    )!;
    let checkboxList =
      exclusionMonth.setDefaultValue?.filter((item: any) => item !== "無") ??
      [];
    let targetObj = exclusionMonth.checkBoxList?.find(
      (item) => item.key === months[month]
    )!;
    if (dayNum <= 10) {
      if (checkboxList.includes(targetObj.label)) return;

      checkboxList.push(targetObj.label);
    } else {
      if (
        (context?.workingDayNum ?? 0) <= 10 ||
        context?.[targetObj.key as keyof IJob_32Props] !== "1"
      ) {
        checkboxList = checkboxList.filter(
          (item: any) => item !== targetObj.label
        );
      }
    }

    exclusionMonth.setDefaultValue = checkboxList;
    setStateInfoList([...resArr]);
  };

  useEffect(() => {
    let resArr = stateFakeTableList.current;
    let exclusionMonth = resArr.find(
      (item) => item.keyword === "exclusionMonth"
    )!;

    // 退職年度のならない月
    exclusionMonth.onGetValue = (e: any) => {
      let value = e?.filter((item: any) => item !== "無")!;

      exclusionMonth.setDefaultValue = !value?.length ? ["無"] : value;
    };

    setStateInfoList([...resArr]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  const makeContextObj = (data: any): IJob_32Props => {
    // ならない月の編集
    const unrecognizedMonths = makeExclusionMonthObj(
      data.exclusionMonth,
      stateInfoList
    );
    // 申請前6か月本俸設定用リストを編集
    const sixMonthsSalaryBeforeApplySettingList =
      context?.sixMonthsSalaryBeforeApplySettingList?.map((item) => {
        const yearMonth = dayjs(`${item.yearMonth}`, "YYYYMM");
        const month = yearMonth.month() + 1;
        const unaccountedMonth = unrecognizedMonths[months[month]];

        if (getFiscalYear(yearMonth) === getFiscalYear(context?.retireDate)) {
          return {
            ...item,
            unaccountedMonth: ["1", "3"].includes(unaccountedMonth) ? "1" : "0",
          };
        }

        return item;
      });

    return {
      ...context,
      ...unrecognizedMonths,
      workingDayNum: data.workingDayNum,
      year: getFiscalYear(context?.retireDate),
      sixMonthsSalaryBeforeApplySettingList,
    };
  };

  const handleSubmit = async (data: any) => {
    const contextValue = makeContextObj(data);
    //退職時の育休出勤日数の登録・整合性チェックAPI 呼び出し
    try {
      const res = await httpAPI_BUS009({
        contractorNo,
        staffNo: context?.staffNo,
        retireDate: context?.retireDate,
        businessType: businessState.common?.businessType,
        workingDayNum: data.workingDayNum!,
      });

      if (res && res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
        return;
      }
    } catch (error) {
      navigate("/error");
    }
    if (isTempSave.current) {
      // 一時保存
      // 退職者詳細情報更新API 呼び出し
      try {
        const param = API_STA008_BuildReqParams({
          ...contextValue,
          contractorNo,
          tempSaveStep: 3,
          businessType: judgeBusinessType(context!),
          screenId: "SCRC060122",
        });
        const res = await httpAPI_STA008(param);

        if (res.resultCd === "I0000") {
          setState({ ...state, errorMsgId: "" });
          setBusinessState({
            ...businessState,
            job_32: {
              ...contextValue,
              applyId: res.applyId,
              updateDateTime: res.updateDateTime,
              tempSaveStep: 3,
            },
          });
          setOpenSuccess(true);
        } else {
          setState({ ...state, errorMsgId: res.resultCd });
        }
      } catch (error) {
        navigate("/error");
      }
    } else {
      // 次へ
      setBusinessState({
        ...businessState,
        job_32: {
          ...contextValue,
        },
      });
      navigate("/SCRC060123");
    }
  };

  // 「育休確認・登録」ボタン押下
  const toChildcareLeavePage = () => {
    if (ref.current === null) return;
    const values = ref.current.getAllValue();

    setBusinessState({
      ...businessState,
      job_32: {
        ...makeContextObj(values),
      },
    });

    navigate("/SCRC060101", { state: { staffNo: context?.staffNo } });
  };

  const submitByRef = (tempSave: boolean) => {
    if (ref.current === null) return;
    isTempSave.current = tempSave;
    ref.current.submit(false);
  };

  return (
    <Box className="SCRC060122" data-testid="SCRC060122PageForTest">
      <TkStepper
        steps={isRetirement ? stepperRetirement : stepperTransfer}
        activeStep={isRetirement ? 2 : 1}
        savaStep={context?.tempSaveStep}
      />

      <TkFakeTable
        ref={ref}
        list={stateInfoList}
        ruleSchema={isJob33 ? schema(dayNum) : {}}
        showButton={false}
        onCheckAndSubmit={handleSubmit}
      />

      <TkTable
        headList={infoHeadTitleList}
        bodyList={childcareLeaveList}
        headerLeftComponent="育休状況"
        headerRightComponent={
          <TkButton onClick={toChildcareLeavePage}>育休確認・登録</TkButton>
        }
      />
      <TkTable
        headList={headListWorkingDayNum}
        bodyList={childcareLeaveWorkingDayNumList}
      />

      <Box className="buttonGroup">
        <TkBackButton />
        <TkButton onClick={() => submitByRef(true)}>一時保存</TkButton>
        <TkButton onClick={() => submitByRef(false)}>次へ</TkButton>
      </Box>

      <TkMessageDialog
        open={openSuccess}
        onOky={() => setOpenSuccess(false)}
        title="一時保存完了"
        contextText="　一時保存が完了しました。"
        okText="はい"
        cancelText=""
      />
    </Box>
  );
};

export default SCRC060122;
